<template>
  <div class="streetViewMap">
    <gmap-street-view-panorama
      class="pano"
      :position="location"
      :pov="street_pov"
      :options="streetOptions"
      @pano_changed="updatePano"
      @pov_changed="updatePov"
      @position_changed="updateLatLng"
    ></gmap-street-view-panorama>
  </div>
</template>

<script>
export default {
  props: ["street_location", "pitch", "zoom", "heading"],
  data() {
    return {
      street_pov: {
        heading: parseFloat(this.heading),
        pitch: parseFloat(this.pitch),
        zoom: this.zoom,
      },
      location: this.street_location,
      street_pano: null,
      streetOptions: {
        streetViewControl: false,
        fullscreenControl: false,
        addressControl: false,
        zoomControl: false,
        panControl: false,
      },
    };
  },
  created() {
    window.EventBus.$on("take_a_snap", (data) => {
      console.log(data);
      this.takeSnap();
    });
  },
  methods: {
    updatePov(pov) {
      // console.log(pov);
      this.street_pov.pitch = pov.pitch;
      this.street_pov.zoom = pov.zoom;
      this.street_pov.heading = pov.heading;
      // console.log(this.street_pov);
    },
    updatePano(pano) {
      console.log(this.location);
      this.street_pano = pano;
      // console.log(this.pano);
    },
    updateLatLng(location) {
      console.log(location);
      this.location.lat = location.lat();
      this.location.lng = location.lng();
    },
    takeSnap() {
      let street_image = `https://maps.googleapis.com/maps/api/streetview?pano=${
        this.street_pano
      }&fov=${180 / Math.pow(2, Math.round(this.street_pov.zoom))}&heading=${
        this.street_pov.heading
      }&pitch=${
        this.street_pov.pitch
      }&size=600x400&key=AIzaSyBTeSQpeOJb1KVmT8Dp0lmUnQ3ZAvvO6xI`;
      this.$emit("get_image", street_image);
    },
  },
};
</script>

<style>
.streetViewMap {
  height: 100%;
}
.pano {
  height: 100%;
}
.pano .vue-street-view-pano {
  border-radius: 10px;
}
</style>
